<template>
  <div class="col-md-12 mb-5">
    <b-form>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <b-input
              placeholder="Tìm kiếm theo tên"
              v-model="searchName"
              append-icon="search"
              single-line
              hide-details
              class="col-md-4 mr-4"
              @keyup="onSearch"
              v-on:keyup.enter="$emit('search')"
              size="sm"
            ></b-input>
            <b-input
              placeholder="Tìm kiếm theo mã"
              v-model="searchCode"
              append-icon="search"
              single-line
              hide-details
              class="col-md-4"
              @keyup="onSearch"
              v-on:keyup.enter="$emit('search')"
              size="sm"
            ></b-input>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'SearchForm',
  data() {
    return {
      searchName: '',
      searchCode: '',
    };
  },
  methods: {
    onSearch() {
      this.$emit('search', {
        name: this.searchName,
        code: this.searchCode,
      });
    },
  },
};
</script> 
